import { render, staticRenderFns } from "./adddeliveryagent.vue?vue&type=template&id=acf5b3a8"
import script from "./adddeliveryagent.vue?vue&type=script&lang=js"
export * from "./adddeliveryagent.vue?vue&type=script&lang=js"
import style0 from "./adddeliveryagent.vue?vue&type=style&index=0&id=acf5b3a8&prod&lang=css"
import style1 from "./adddeliveryagent.vue?vue&type=style&index=1&id=acf5b3a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports